import { render, staticRenderFns } from "./safety-tips.vue?vue&type=template&id=6c1e50fa&scoped=true"
import script from "./safety-tips.vue?vue&type=script&lang=js"
export * from "./safety-tips.vue?vue&type=script&lang=js"
import style0 from "./safety-tips.vue?vue&type=style&index=0&id=6c1e50fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c1e50fa",
  null
  
)

export default component.exports